<template>
  <div class="listTable">
    <el-table :data="tableData" border style="width: 100%" size="mini">
      <!-- <el-table-column
        prop="dictDepositType"
        label="保证金类型"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <CommonSelect
            :disabled="readOnly"
            size="mini"
            bindLabel="dictValue"
            bindKey="dictKey"
            bindValue="dictValue"
            methods="get"
            dataMethod="params"
            dataUrl="/blade-system/dict-biz/dictionary?code=dict_deposit_type"
            :bindId="scope.row.dictDepositType ? scope.row.dictDepositType : ''"
            @handleChange="(el) => setId(el, scope.$index, 'dictDepositType')"
          />
        </template>
      </el-table-column> -->
      <el-table-column prop="outlayAmount" label="保证金收取金额" align="center">
        <template slot-scope="scope">
          <div class="flex_wrapper">
          <el-input
            :disabled="readOnly"
            v-model="scope.row['outlayRate']"
            placeholder=""
            size="mini"
            @change="
              changeInput('outlayAmount', 'outlayRate', 'ratio', scope.$index)
            "
          >
            <template slot="append">%</template>
          </el-input>

          <el-input
            :disabled="readOnly"
            v-model="scope.row['outlayAmount']"
            placeholder=""
            size="mini"
            @change="
              changeInput('outlayRate', 'outlayAmount', 'number', scope.$index)
            "
          >
            <template slot="append">元</template>
          </el-input>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="outlayWay"
        label="收取方式"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <CommonSelect
            :disabled="readOnly"
            size="mini"
            bindLabel="dictValue"
            bindKey="dictKey"
            bindValue="dictValue"
            methods="get"
            dataMethod="params"
            dataUrl="/blade-system/dict-biz/dictionary?code=fee_collection_method"
            :bindId="scope.row.outlayWay ? scope.row.outlayWay : ''"
            @handleChange="(el) => setId(el, scope.$index, 'outlayWay')"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="expirationTreatment"
        label="到期处理方式"
        align="center"
        width="110"
      >
        <template slot-scope="scope">
          <CommonSelect
            :disabled="readOnly"
            size="mini"
            bindLabel="dictValue"
            bindKey="dictKey"
            bindValue="dictValue"
            methods="get"
            dataMethod="params"
            dataUrl="/blade-system/dict-biz/dictionary?code=expiration_treatment"
            :bindId="
              scope.row.expirationTreatment ? scope.row.expirationTreatment : ''
            "
            @handleChange="
              (el) => setId(el, scope.$index, 'expirationTreatment')
            "
          />
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="depositRate"
        label="保证金利率"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <el-input
            v-model="scope.row['depositRate']"
            placeholder=""
            size="mini"
          >
            <template slot="append">%</template>
          </el-input>
        </template>
      </el-table-column> -->
      <el-table-column label="操作" v-if="!readOnly" align="center" width="50">
        <template slot-scope="scope">
          <div class="del_color" @click="del(scope.$index)">
            <i class="el-icon-delete-solid"></i>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="table_custom_add" v-if="!readOnly">
      <el-button icon="el-icon-circle-plus-outline" @click="add" size="mini"
        >添加</el-button
      >
    </div>
  </div>
  <!-- 
    *     <tableCustom :tableData="tableData"  />
    *    
    *     
    *     
    *
    *
    *
    *
    *
    *
    *
   -->
</template>

<script>
import * as api from "@/api/text/text";
import { floatMul,floatDiv } from "@/util/util"
import CommonSelect from "@/components/commonSelect/commonSelect";
export default {
  name: "accessory",
  data() {
    return {};
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    quotationPrice: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    quotationPrice: {
      handler: function (val) {
        this.tableData.map((item) => {
          if (item.outlayRate) {
            item.outlayAmount = floatDiv(floatMul(Number(this.quotationPrice) , Number(item.outlayRate)),100)
            
            // (
            //   (Number(this.quotationPrice) * Number(item.outlayRate)) /
            //   100
            // ).toFixed(2);
          } else if (item.outlayAmount) {
            item.outlayRate = floatMul(floatDiv(Number(item.outlayAmount),Number(this.quotationPrice)),100)
            // (
            //   (Number(item.outlayAmount) / Number(this.quotationPrice)) *
            //   100
            // ).toFixed(4);
          }
        });
      },
      deep: true,
    },
  },
  computed: {},
  components: {
    CommonSelect,
  },
  created() {},
  methods: {
    changeInput(toName, name, type, index) {
      let tableData = this.tableData;
      if (this.quotationPrice) {
        if (type == "ratio") {
          tableData[index][toName] =floatDiv(floatMul(Number(this.quotationPrice) , Number(tableData[index][name])),100)
          //  (
          //   (Number(this.quotationPrice) * Number(tableData[index][name])) /
          //   100
          // ).toFixed(2);
        } else {
          tableData[index][toName] =floatMul(floatDiv(Number(tableData[index][name]),Number(this.quotationPrice)),100)
          //  (
          //   (Number(tableData[index][name]) / Number(this.quotationPrice)) *
          //   100
          // ).toFixed(4);
        }

        this.$nextTick(() => {
          this.tableData = tableData;
        });
      }
    },
    del(index) {
      this.$confirm("是否删除此条数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.tableData.splice(index, 1);
      });
    },
    add() {
      this.tableData.push({
        outlayAmount: "",
        outlayRate: "",
        dictMainOutlayType: 2,
        dictDepositType: 1,
        outlayWay: "",
        expirationTreatment: "",
        depositRate: "",
      });
    },
    setId(item, index, name) {
      this.$nextTick(() => {
        this.tableData[index][name] = item.dictKey;
        this.tableData[index][name + "Name"] = item.dictValue;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.listTable {
  background-color: #fff;
  margin-top: 4px;
}
.table_custom_add {
  padding: 4px 0;
  text-align: center;
}
.el-table {
  border: 1px solid #e2e2e2;
  border-right: none;
  border-bottom: none;
  th {
    background: #f2f2f2;
    color: #333;
  }
}
.action_block {
  display: flex;
  flex-direction: row;
  a {
    cursor: pointer;
    margin: 0 8px;
  }
}
.del_color {
  color: #409eff;
}
/deep/ .el-button {
  padding: 6px 12px;
}
/deep/ .el-input-number {
  width: auto !important;
}
/deep/ .el-date-editor.el-input {
  width: auto !important;
}
/deep/ .avue-crud__menu {
  display: none;
}
.flex_wrapper {
  display: flex;
  align-items: center;
}
/deep/ .el-input-group__append {
  padding: 0 5px;
}
/deep/ .el-input__inner {
  padding: 0 5px;
}
/deep/ .el-table .cell,
.el-table th > .cell {
  padding-left: 5px;
  padding-right: 5px;
}
/deep/ .el-table__empty-text {
  line-height: 38px;
}
/deep/ .el-table__empty-block {
  min-height: 38px;
}
</style>

